import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { KOBOO_BLUE, KOBOO_LIGHT_GREY, KOBOO_RED_ERROR } from '../../constants/colors';
import { resetError, resetInfo } from '../../store/infos/actions';

const styles = theme => (
  {
    error: {
      backgroundColor: KOBOO_RED_ERROR,
    },
    success: {
      backgroundColor: KOBOO_BLUE,
    },
    buttonText: {
      color: KOBOO_LIGHT_GREY,
    },
  }
);

export class KobooSnackBar extends Component {

  static propTypes = {
    resetError: PropTypes.func.isRequired,
    resetInfo: PropTypes.func.isRequired,
    error: PropTypes.string,
    info: PropTypes.string,
  };

  static defaultProps = {
    error: null,
    info: null,
  };

  handleErrorSnackbarClose = () => {
    this.props.resetError();
  };

  handleInfoSnackbarClose = () => {
    this.props.resetInfo();
  };

  // Render
  render() {
    const {
      error,
      info,
      classes
    } = this.props;
    console.log(error);
    return (
      <div>
        <Snackbar
          ContentProps={{
            classes: {
              root: classes.error,
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={error !== null}
          message={error || ''}
          onClose={this.handleErrorSnackbarClose}
          action={[
            <Button
              id="error"
              key="undo"
              className={classes.buttonText}
              color="secondary"
              size="small"
              onClick={this.handleErrorSnackbarClose}
            >
              Fermer
            </Button>,
          ]}
        />

        <Snackbar
          ContentProps={{
            classes: {
              root: classes.success,
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={info !== null}
          message={info || ''}
          autoHideDuration={4000}
          onClose={this.handleInfoSnackbarClose}
          action={[
            <Button
              id="info"
              key="ok"
              className={classes.buttonText}
              color="secondary"
              size="small"
              onClick={this.handleInfoSnackbarClose}
            >
              OK
            </Button>,
          ]}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state.infos.error,
    info: state.infos.info,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { resetError, resetInfo }),
)(KobooSnackBar);


// WEBPACK FOOTER //
// ./src/components/Layout/KobooSnackBar.jsx